import { Leaf, ShieldCheck, Clock } from "lucide-react";
import Reveal from "@/components/Reveal";

const ABOUT_IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_contact-connect-59/artifacts/6xtsutrm_IMG_1807.jpeg";

const VALUES = [
  {
    icon: Leaf,
    title: "Materiales seleccionados",
    text: "Madera, mármol y herrajes elegidos pieza por pieza en cada proyecto.",
  },
  {
    icon: Clock,
    title: "Fechas cumplidas",
    text: "Un cronograma claro desde el día uno y actualizaciones constantes.",
  },
  {
    icon: ShieldCheck,
    title: "Garantía por escrito",
    text: "Cada instalación queda respaldada con garantía formal de nuestro taller.",
  },
];

export default function About() {
  return (
    <section id="nosotros" className="py-24 lg:py-32" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-12 lg:px-12">
        <div className="relative lg:col-span-5">
          <Reveal y={36}>
            <div
              className="aspect-[4/5] overflow-hidden rounded-t-[999px] rounded-b-[32px]"
              data-testid="about-image-frame"
            >
              <img
                src={ABOUT_IMG}
                alt="Detalle de gabinetes y respaldo de madera en cocina de Toscana"
                className="h-full w-full object-cover"
                loading="lazy"
                data-testid="about-image"
              />
            </div>
          </Reveal>
          <Reveal
            delay={0.2}
            className="absolute -bottom-6 right-0 max-w-[240px] rounded-2xl border border-cream-border bg-card p-6 shadow-[0_18px_40px_rgba(13,21,38,0.12)] sm:right-8"
          >
            <p className="font-serif text-xl leading-snug text-olive">
              Hecho a mano, hecho para durar.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 lg:pl-10">
          <Reveal>
            <p className="eyebrow">Nosotros</p>
            <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-tight tracking-tight text-olive sm:text-5xl lg:text-6xl">
              Mucho gusto, soy Antonio.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-7 max-w-2xl text-lg leading-relaxed text-olive-mid">
              Desde mi taller en Uruapan, Michoacán, diseño, fabrico e instalo
              cocinas integrales cálidas, generosas y hechas para vivirse. Me
              gusta conocer a la familia que va a estrenar su cocina antes de
              cortar la primera tabla.
            </p>
            <p className="mt-5 max-w-2xl leading-relaxed text-olive-mid">
              No creo en cocinas de catálogo. Creo en espacios que se adaptan
              a tu familia, tus rutinas y tu forma de recibir gente; por eso
              cada proyecto lo reviso personalmente, del boceto a la
              instalación.
            </p>
            <p
              className="mt-5 max-w-2xl leading-relaxed text-olive-mid"
              data-testid="about-owner-note"
            >
              Si tienes dudas, grande o pequeña, pregúntame con confianza: mi
              teléfono y la puerta del taller están siempre abiertos para ti.
            </p>
          </Reveal>

          <div className="mt-12 grid gap-8 sm:grid-cols-3">
            {VALUES.map((value, i) => (
              <Reveal key={value.title} delay={0.1 + i * 0.1}>
                <value.icon className="h-6 w-6 text-terracotta" strokeWidth={1.5} />
                <h3 className="mt-4 font-serif text-xl text-olive">
                  {value.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-olive-mid">
                  {value.text}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
